import React from 'react';
import PropTypes from 'prop-types';
import DocumentsOverviewTable from './DocumentsOverviewTable';

const DocumentsOverviewTab = ({ organisationId, urlRoot }) => (
  <DocumentsOverviewTable organisationId={organisationId} urlRoot={urlRoot} />
);

DocumentsOverviewTab.propTypes = {
  organisationId: PropTypes.string.isRequired,
  urlRoot: PropTypes.string.isRequired,
};

export default DocumentsOverviewTab;
